<template>
    <v-list-item
        v-if="asListItem"
        @click="toggleTheme"
        :prepend-icon="themeIcon"
        title="Tema"
    />
    <v-btn
        v-else
        density="compact"
        size="medium"
        @click="toggleTheme"
        :icon="themeIcon"
    />
</template>

<script lang="ts" setup>
import { onMounted, computed, defineProps } from 'vue';
import { useTheme } from 'vuetify';

const props = defineProps({
    asListItem: {
        type: Boolean,
        default: false
    }
});

const localStorageTheme = localStorage.getItem('theme') as string;
const theme = useTheme();

const themeIcon = computed(() => {
    const themeIsDark = theme.global.current.value.dark;
    if (!themeIsDark) {
        return 'mdi-white-balance-sunny';
    }
    return 'mdi-moon-waxing-crescent';
})

function toggleTheme() {
    theme.global.name.value = theme.global.current.value.dark ? 'light' : 'dark';
    localStorage.setItem('theme', theme.global.name.value);
}

onMounted(() => {
    if (localStorageTheme) {
        theme.global.name.value = localStorageTheme;
    }
})
</script>

<style lang="scss" scoped>

</style>